export const mergeStatisticToForecastData = (forecastArray, statisticArray) => {
  const statisticMap = new Map(
    statisticArray.map((item) => {
      const key = `${item.weekDay}_${item.ticketType || 'default'}`;
      const zonesMap = new Map(
        item.groups.map((zone) => [
          zone.id,
          {
            rolling_weeks: zone.rollingWeekTickets,
            to_reset_tickets: zone.averageTicket,
            latest_routes: zone.lastTotalTickets,
          },
        ]),
      );
      return [key, zonesMap];
    }),
  );

  return forecastArray.map((forecast) => {
    const key = `${forecast.week_day}_${forecast.ticket_type || 'default'}`;

    const newGroups = forecast.groups.map((zone) => {
      const statisticZonesMap = statisticMap.get(key);
      if (statisticZonesMap && statisticZonesMap.has(zone.id)) {
        return {
          ...zone,
          ...statisticZonesMap.get(zone.id),
        };
      }
      return zone;
    });

    return {
      ...forecast,
      groups: newGroups,
    };
  });
};
